import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const Ctx = createContext(null);

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(null);
  useEffect(() => {
    api.get("/public/config").then((r) => setConfig(r.data)).catch(() => setConfig({ services: [], addons: [], pricing: {}, zip_fees: [], business: {}, schedule: {} }));
  }, []);
  return <Ctx.Provider value={config}>{children}</Ctx.Provider>;
}

export const useConfig = () => useContext(Ctx);
